// Parsed from /public/bank/2026.04-dsk-bank.csv
import type { MockBankTransaction } from '../store'

export const bankTransactionsFixture: MockBankTransaction[] = [
  {
    id: 'txn-2026-04-30-fee',
    booking_ts: '2026-04-30T00:00:00Z',
    description: 'Automatic service fee',
    counterparty_name: '',
    reference: '',
    amount: -20.45,
    currency: 'EUR',
    matched: false,
  },
  {
    id: 'txn-2026-04-28-hetzner',
    booking_ts: '2026-04-28T00:00:00Z',
    description: 'POS payment 26.04.2026 - card op 5704',
    counterparty_name: 'DEU GUNZENHAUSEN HETZNER ONLINE GMBH',
    reference: 'A52239',
    amount: -32.13,
    currency: 'EUR',
    matched: true,
    match_invoice_ids: ['inv-hetzner-2026-04'],
  },
  {
    id: 'txn-2026-04-22-screenshotone',
    booking_ts: '2026-04-22T00:00:00Z',
    description: 'POS payment 17.00 USD 21.04.2026',
    counterparty_name: 'PRT Lisboa PADDLE NET SCRSHOTONE',
    reference: 'A02705',
    amount: -14.98,
    currency: 'EUR',
    matched: true,
    match_invoice_ids: ['inv-screenshotone'],
  },
  {
    id: 'txn-2026-04-09-doo',
    booking_ts: '2026-04-09T00:00:00Z',
    description: 'Social security - personnel 03/2026',
    counterparty_name: 'National Revenue Agency',
    reference: 'BG97BNBG96618000112001',
    amount: -216.96,
    currency: 'EUR',
    matched: false,
  },
  {
    id: 'txn-2026-04-09-vat',
    booking_ts: '2026-04-09T00:00:00Z',
    description: 'VAT per return for 03/2026',
    counterparty_name: 'National Revenue Agency',
    reference: 'BG88BNBG96618000195001',
    amount: -21.82,
    currency: 'EUR',
    matched: false,
  },
  {
    id: 'txn-2026-04-09-abratax',
    booking_ts: '2026-04-09T00:00:00Z',
    description: 'Invoice 2180 01.04.2026 - service fee 03/2026',
    counterparty_name: 'ABRATAX EOOD',
    reference: 'BG40UNCR70001522251681',
    amount: -160.00,
    currency: 'EUR',
    matched: false,
  },
  {
    id: 'txn-2026-04-09-nzok',
    booking_ts: '2026-04-09T00:00:00Z',
    description: 'Health insurance - personnel 03/2026',
    counterparty_name: 'National Revenue Agency',
    reference: 'BG16BNBG96618000112101',
    amount: -88.10,
    currency: 'EUR',
    matched: false,
  },
  {
    id: 'txn-2026-04-09-dzpo',
    booking_ts: '2026-04-09T00:00:00Z',
    description: 'Supplementary pension - personnel 03/2026',
    counterparty_name: 'National Revenue Agency',
    reference: 'BG65BNBG96618000111801',
    amount: -55.06,
    currency: 'EUR',
    matched: false,
  },
  {
    id: 'txn-2026-04-07-paddle-payout',
    booking_ts: '2026-04-07T00:00:00Z',
    description: 'Payout 220820 - ISW0704260000141',
    counterparty_name: 'Paddle.com Market Limited',
    reference: 'IE84CHAS93090379620843',
    amount: 263.70,
    currency: 'EUR',
    matched: true,
    match_invoice_ids: ['inv-paddle-gb', 'inv-paddle-us', 'inv-paddle-remittance'],
  },
  {
    id: 'txn-2026-04-06-supabase',
    booking_ts: '2026-04-06T00:00:00Z',
    description: 'POS payment 34.97 USD 05.04.2026',
    counterparty_name: 'SGP SINGAPORE SUPABASE',
    reference: 'B11341',
    amount: -31.47,
    currency: 'EUR',
    matched: true,
    match_invoice_ids: ['inv-supabase'],
  },
]
